export enum ContractType {
  Customer = 'CUSTOMER',
  Fleet = 'FLEET',
  Freelance = 'FREELANCE',
}

export enum ContractForUserType {
  Customer = 'CUSTOMER',
  Fleet = 'FLEET',
}

export enum ContractSubtype {
  Madar = 'MADAR',
  FleetCustomer = 'FLEET_CUSTOMER',
  GlobalSpecific = 'GLOBAL_SPECIFIC',
}

export enum ContractAction {
  AddContract = 'AddContract',
  EditContract = 'EditContract',
  AddTradeLane = 'AddTradeLane',
  EditTradeLane = 'EditTradeLane',
  AddCustomerFleetContract = 'AddCustomerFleetContract',
  EditCustomerFleetContract = 'EditCustomerFleetContract',
  AddCustomerFleetTradeLane = 'AddCustomerFleetTradeLane',
  EditCustomerFleetTradeLane = 'EditCustomerFleetTradeLane',
  EditGlobalSpecificContract = 'EditGlobalSpecificContract',
  AddGlobalSpecificTradeLane = 'AddGlobalSpecificTradeLane',
  EditGlobalSpecificTradeLane = 'EditGlobalSpecificTradeLane',
  DeleteTradeLane = 'DeleteTradeLane',
}

export enum ContractActionItem {
  Add = 'add',
  Deleted = 'deleted',
  Updated = 'updated'
}

export enum ContractUnifiedTypes {
  Global = 'MADAR',
  GlobalCustomer = 'CUSTOMER',
  GlobalFleet = 'FLEET',
  GlobalSpecific = 'GLOBAL_SPECIFIC',
  PrivateSpecific = 'FLEET_CUSTOMER',
}
